<template>
	<div class="w-100">
		<div
			@click="openForm"
			:class="[
				'cal-btn',
				'fontS14',
				'orange',
				'd-flex',
				'space-between',
				'align-center',
				{ 'mb-2': showForm },
			]"
		>
			<span class="ml-3">Calcular envío</span>
			<i
				:class="[
				'el-icon-arrow-down',
				'bold',
				'fontS16',
				'mr-3',
				'close',
				{ 'rotate': showForm },
				]"
			></i>
		</div>
		<transition name="fade" mode="out-in">
			<el-form
				v-if="showCalcForm"
				class="d-flex wrap"
				:model="shippingCost"
			>
				<el-form-item prop="departmentId" class="flex-95 mx-1 my-0">
					<select-component
						clearable
						second-style
						placeholder="Departamento"
						:options="departments"
						item-text="name"
						:value="shippingCost.departmentName"
						@input="onDepartamenChange($event)"
					/>
				</el-form-item>
				<el-form-item prop="province" class="flex-95 mx-1 my-0">
					<select-component
						clearable
						second-style
						placeholder="Provincia"
						:options="provinces"
						item-text="name"
						:value="shippingCost.provinceName"
						@input="onProvinceChange($event)"
						:disabled="!shippingCost.departmentName"
					/>
				</el-form-item>
				<el-form-item prop="district" class="flex-95 mx-1 my-0">
					<select-component
						clearable
						second-style
						placeholder="Distrito"
						:options="districts"
						item-text="name"
						:value="shippingCost.districtName"
						:disabled="!shippingCost.provinceName"
						@input="shippingCost.districtName = $event.name"
					/>
				</el-form-item>
				<el-form-item class="flex-95 mx-1 my-0">
					<button
						class="calc-btn-action w-100 uppercase bold fontS14 pointer"
						type="button"
						:class="{ 'disable-style': !shippingCost.departmentName }"
						:disabled="!shippingCost.departmentName"
						@click="calculate"
					>Calcular</button>
				</el-form-item>
			</el-form>
		</transition>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

function created() {
	this.loadDepartments();
}

async function loadDepartments() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	({ data: this.departments } = await this.$httpJapi.get('province', { headers }));
}

function openForm() {
	if (this.flagPickUp === 1) {
		this.showForm = !this.showForm;
	}
}

async function onProvinceChange({ id, name }) {
	this.shippingCost.provinceName = name;
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	({ data: this.districts } = await this.$httpJapi.get(`parish/${id}`, { headers }));
}

async function onDepartamenChange(department) {
	const { id, name } = department;
	this.shippingCost.departmentName = name;
	this.provinceId = id;
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	({ data: this.provinces } = await this.$httpJapi.get(`cities/${id}`, { headers }));
}

async function calculate() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const url = '/weight/price';
	const body = this.buildBody();
	try {
		const { data: shippingCost } = await this.$httpQtc.post(url, body, { headers });
		this.$store.commit('SET_SHIPPING_COST', shippingCost);
		this.openForm();
	} catch (error) {
		if (error.response.data.message === 'PRICE_NOT_CONFIGURATION') {
			this.$store.commit('SET_SHIPPING_COST', null);
			this.$message({
				message: 'No es posible hacer envios a ese destino.',
				type: 'error',
			});
		}
	}
}

function buildBody() {
	const details = this.productsSelected.map((p) => {
		const newP = {};
		newP.weight = p.weigth || 0;
		newP.quantity = p.quantity;
		return newP;
	});
	return {
		details,
		provinceId: this.provinceId,
	};
}

function showCalcForm() {
	return this.showForm;
}

function showShippingCost() {
	return this.shippingCostAmount && !this.showForm;
}

function data() {
	return {
		departments: [],
		districts: [],
		provinceId: 0,
		provinces: [],
		shippingCost: {
			departmentName: '',
			districtName: '',
			provinceName: '',
		},
		showForm: false,
	};
}

export default {
	name: 'shipping-cost',
	components: {
		selectComponent: () => import('@/components/selectComponent'),
	},
	computed: {
		...mapGetters([
			'flagPickUp',
			'getCurrencySymbol',
			'productsSelected',
			'shippingCostAmount',
			'token',
		]),
		showCalcForm,
		showShippingCost,
	},
	created,
	data,
	methods: {
		buildBody,
		calculate,
		loadDepartments,
		onDepartamenChange,
		onProvinceChange,
		openForm,
	},
	props: {
		products: {
			default: () => [],
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
	.cal-btn {
		border-bottom: 0.1rem solid color(leadLight);
		border-top: 0.1rem solid color(leadLight);
		cursor: pointer;
		padding: 0.5rem 0;
	}
	.calc-btn-action {
		background-color: transparent;
		border: 0.1rem solid color(defaultOrange);
		border-radius: 0.8rem;
		color: color(defaultOrange);
		cursor: pointer;
		height: 3.3rem;
	}

	.close {
		transform: rotate(0deg);
		transition: 200ms transform cubic-bezier(0.25, 0.46, 0.45, 0.94);
	}

	.rotate {
		transform: rotate(180deg);
	}

	.disable-style {
		cursor: not-allowed;
		opacity: 0.4;
	}
</style>




// WEBPACK FOOTER //
// shippingCost.vue?64956817